export const en = {
  // Menu
  "menu.dashboard": "Dashboard",
  "menu.announcements": "Announcements",
  "menu.transparency": "Transparency",
  "menu.access": "Access & QR",
  "menu.amenities": "Amenities",
  "menu.payments": "Payments & Finance",
  "menu.cobranza": "Collections",
  "menu.polls": "Polls",
  "menu.incidents": "Reports & Incidents",
  "menu.documents": "Documents",
  "menu.logout": "Logout",
  "menu.admin": "Administration",
  "menu.directory": "Directory",
  "menu.restrictions": "Restrictions",
  "menu.emergency": "Emergencies",
  "menu.notifications": "Notifications",
  "menu.profile": "My Profile",
  "menu.settings": "Settings",
  "menu.help": "Help",
  "menu.logoutTitle": "Logout",
  "menu.logoutMessage": "Are you sure you want to log out?",
  "menu.version": "Version 1.0.0",
  "menu.reports": "Reports",
  "menu.logbook": "Logbook",
  "menu.patrol": "Patrol",
  "menu.suppliers": "Suppliers",
  "menu.inventory": "Inventory",
  "menu.cameras": "Live Cameras",

  // Menu Categories
  "menu.categories.main": "Main",
  "menu.categories.community": "Community",
  "menu.categories.access": "Access",
  "menu.categories.engagement": "Engagement",
  "menu.categories.finances": "Finances",
  "menu.categories.security": "Security",
  "menu.categories.operations": "Operations",
  "menu.categories.admin": "Administration",
  "menu.categories.configuration": "Configuration",

  // Documents
  "docs.title": "Document Library",
  "docs.upload": "Upload Document",
  "docs.empty": "No documents available.",
  "docs.cat.bylaws": "Bylaws",
  "docs.cat.minutes": "Assembly Minutes",
  "docs.cat.financial": "Financial Statements",
  "docs.cat.notices": "Notices",
  "docs.cat.insurance": "Policies & Insurance",
  "docs.cat.other": "Other",
  "docs.upload.modal": "Publish Document",
  "docs.upload.title": "File Title",
  "docs.upload.category": "Category",
  "docs.upload.file": "Select File",

  // Profile
  "profile.title": "My Home",
  "profile.tab.info": "Personal Information",
  "profile.tab.family": "Family & Residents",
  "profile.tab.vehicles": "Vehicles",
  "profile.tab.pets": "Pets",
  "profile.role": "Resident Type",
  "profile.unit": "Unit",
  "profile.member.add": "Add Member",
  "profile.member.name": "Name",
  "profile.member.relation": "Relationship",
  "profile.member.age": "Age",
  "profile.relation.spouse": "Spouse",
  "profile.relation.child": "Child",
  "profile.relation.parent": "Parent",
  "profile.relation.staff": "Service Staff",
  "profile.relation.other": "Other",
  "profile.family.fullName": "Full name",
  "profile.family.age": "Age",
  "profile.family.relation": "Relationship",
  "profile.family.emailNote": "An access link will be sent to this email",
  "profile.family.description": "Household members with access to the unit",
  "profile.family.registerTitle": "Register household member",
  "profile.family.add": "Add member",
  "profile.family.empty": "No household members registered",
  "profile.family.accountActive": "Active account",
  "profile.family.permanentAccess": "Permanent access",
  "profile.family.resendInvite": "Resend invitation",
  "profile.family.viewQr": "View QR",
  "profile.vehicle.plate": "Plate",
  "profile.vehicle.alias": "Alias / Model",
  "profile.vehicle.status": "Access Status",
  "profile.pets.add": "Register Pet",
  "profile.pets.empty": "No pets registered.",
  "profile.pets.type": "Type",
  "profile.pets.breed": "Breed",
  "profile.pets.color": "Color",
  "profile.pets.age": "Age",
  "profile.pets.vaccines": "Vaccines",
  "profile.pets.tag": "Digital Tag",
  "profile.pets.tag_desc": "Scan this code to see the owner's contact information.",
  "profile.pets.modal.title": "Pet's Information",
  "profile.pets.modal.name": "Name",
  "profile.pets.modal.chip": "Chip ID / Registry",
  "profile.pets.vaccine.add": "Add Vaccine",
  "profile.pets.vaccine.name": "Vaccine Name",
  "profile.pets.vaccine.date": "Application Date",
  "profile.pets.title": "Pets",
  "profile.pets.name": "Name",
  "profile.pets.description": "Register your household pets",
  "profile.pets.lostScanHere": "Scan this code to see the owner's contact information.",
  "profile.vehicles.add": "Add vehicle",
  "profile.vehicles.description": "Vehicles registered in your household",
  "profile.vehicles.makeModel": "Make / Model",
  "profile.vehicles.makeModelPlaceholder": "e.g. Honda Civic 2023",
  "profile.vehicles.plateNumber": "Plate number",
  "profile.vehicles.register": "Register",
  "profile.vehicles.registerTitle": "Register vehicle",
  "profile.fiscal.title": "Tax Information",
  "profile.fiscal.businessName": "Business Name",
  "profile.fiscal.taxRegime": "Tax Regime",
  "profile.fiscal.zipCode": "ZIP Code",
  "profile.fiscal.address": "Address",
  "profile.fiscal.email": "Email",
  "profile.fiscal.registerNow": "Register now",
  "profile.security": "Security",
  "profile.changePassword": "Change Password",
  "profile.currentPassword": "Current Password",
  "profile.newPassword": "New Password",
  "profile.confirmPassword": "Confirm Password",
  "profile.passwordChanged": "Password changed successfully",
  "profile.passwordMismatch": "Passwords do not match",
  "profile.passwordTooShort": "Password must be at least 6 characters",
  "profile.incorrectPassword": "The current password is incorrect",
  "profile.contact.title": "Contact Information",
  "profile.phone.label": "Phone",
  "profile.phone.updated": "Phone updated successfully",
  "profile.status.ACTIVE": "Active",
  "profile.status.INACTIVE": "Inactive",
  "profile.status.BLOCKED": "Blocked",
  "profile.status.blocked": "Blocked",
  "profile.security.title": "Security",
  "profile.password.change": "Change Password",
  "profile.password.current": "Current Password",
  "profile.password.new": "New Password",
  "profile.password.confirm": "Confirm Password",
  "profile.password.changed": "Password changed successfully",
  "profile.password.mismatch": "Passwords do not match",
  "profile.password.tooShort": "Password must be at least 6 characters",
  "profile.password.incorrect": "The current password is incorrect",
  "profile.phone.notRegistered": "No phone has been registered",
  "profile.avatar.updated": "Profile picture updated successfully",

  // Access Control
  "access.title": "Access Control",
  "access.tab.my_qr": "My QR",
  "access.tab.guests": "Invitations",
  "access.tab.my_cards": "My Cards",
  "access.tab.logs": "History",
  "access.tab.cameras": "Cameras",
  "access.remote_open": "Remote Opening",
  "access.remote_warning": "Only use this feature if you have visibility of the door.",
  "access.door.pedestrian": "Pedestrian Entrance",
  "access.door.vehicle": "Vehicle Gate",
  "access.pin.title": "Forgot your phone?",
  "access.pin.subtitle": "Your personal access PIN:",
  "access.pin.change": "Change PIN",
  "access.pin.update_success": "PIN updated successfully",

  // Guests
  "guest.create_btn": "New Invitation",
  "guest.empty": "You have no active invitations.",
  "guest.subtitle": "Manage access for your visits, services, or packages.",
  "guest.form.title": "Create Access Pass",
  "guest.form.name": "Visitor's Name",
  "guest.form.name_ph": "e.g. John Doe, DHL, Totalplay",
  "guest.form.type": "Type of Visit",
  "guest.form.validity": "Access Validity",
  "guest.form.plate": "License Plate (Optional - LPR)",
  "guest.form.notes": "Notes for Guard",
  "guest.form.submit": "Generate Access",
  "guest.form.cancel": "Cancel",

  "guest.type.visit": "Social Visit",
  "guest.type.service": "Service / Maintenance",
  "guest.type.delivery": "Package / Delivery",
  "guest.type.party": "Event / Party",

  "guest.validity.once": "Single use (24h)",
  "guest.validity.range": "Date Range",
  "guest.validity.permanent": "Permanent (Family/Staff)",

  "guest.status.active": "ACTIVE",
  "guest.status.expired": "EXPIRED",
  "guest.status.future": "SCHEDULED",

  "guest.ticket.title": "Access Pass",
  "guest.ticket.pin": "ACCESS PIN",
  "guest.ticket.share_msg": "Share this code with your visitor",
  "guest.ticket.valid_until": "Valid until:",

  // Logs
  "log.header.date": "Date and Time",
  "log.header.user": "User / Visitor",
  "log.header.method": "Method",
  "log.header.entry": "Access Point",
  "log.header.status": "Status",
  "log.header.photos": "Photos",
  "log.method.qr_resident": "Resident QR",
  "log.method.qr_guest": "Guest QR",
  "log.method.qr_hik": "HIK QR",
  "log.method.lpr": "License Plate Reader",
  "log.method.manual": "Manual Opening",
  "log.method.app_remote": "Remote App",
  "log.method.rfid": "RFID",
  "log.method.pin": "PIN",
  "log.method.remote_open": "Remote Opening",
  "log.method.faceid": "Facial Recognition",
  "log.status.granted": "Allowed",
  "log.status.denied": "Denied",

  // Amenities
  "amenities.title": "Book Amenities",
  "amenities.balance": "Available balance",
  "amenities.book_btn": "Book Now",
  "amenities.capacity": "Cap",
  "amenities.free": "Free",
  "amenities.deposit_req": "Requires deposit",
  "amenities.no_deposit": "No deposit",
  "amenities.my_reservations": "My Reservations",
  "amenities.list.empty": "You have no upcoming reservations.",
  "amenities.list.date": "Date",
  "amenities.list.amenity": "Area",
  "amenities.list.cost": "Total Cost",
  "amenities.list.status": "Status",
  "amenities.list.actions": "Actions",
  "amenities.status.pending": "Pending",
  "amenities.status.confirmed": "Confirmed",
  "amenities.status.cancelled": "Cancelled",
  "amenities.cancel.modal_title": "Cancel Reservation",
  "amenities.cancel.modal_body": "You are about to cancel your <strong>{{amenity}}</strong> reservation on <strong>{{date}}</strong>. This action cannot be undone.",
  "amenities.cancel.keep": "Keep Reservation",
  "amenities.cancel.confirm": "Yes, Cancel",
  "amenities.cancel.error_message": "Error canceling reservation",

  "amenities.errors.title": "Error",
  "amenities.errors.slotTaken": "Someone already booked that time slot. Please choose another available time.",

  // Amenity Wizard
  "amenities.wizard.title": "Booking Wizard",
  "amenities.wizard.step": "Step",
  "amenities.wizard.of": "of",
  "amenities.wizard.step1": "Date & Time",
  "amenities.wizard.step2": "Contract",
  "amenities.wizard.step3": "Confirmation",
  "amenities.wizard.next": "Next",
  "amenities.wizard.back": "Back",
  "amenities.wizard.selectTime": "Please select a start time.",
  "amenities.wizard.acceptTerms": "You must accept the rules and terms to continue.",

  "amenities.slots.available": "Available",
  "amenities.slots.occupied": "Occupied",
  "amenities.slots.selected": "Selected",
  "amenities.slots.past": "Past",

  "amenities.legend.selected": "Selected",
  "amenities.legend.available": "Available",
  "amenities.legend.occupied": "Occupied",
  "amenities.legend.past": "Past",

  "amenities.contract.title": "Rules & Terms",
  "amenities.contract.rules": "Area Rules",
  "amenities.contract.terms": "Terms and Conditions",
  "amenities.contract.accept": "I have read and agree to the rules and terms of use.",

  "amenities.modal.title": "New Reservation",
  "amenities.modal.date": "Date",
  "amenities.modal.start_time": "Start Time",
  "amenities.modal.hours": "Duration (Hours)",
  "amenities.modal.selectStartTime": "Select a start time",
  "amenities.modal.bookingRange": "Booking",
  "amenities.modal.hoursLabel": "hrs",
  "amenities.modal.checkingAvailability": "Checking availability...",
  "amenities.modal.loadingAvailability": "Checking availability...",
  "amenities.modal.closedDay": "The area is closed on this day.",
  "amenities.modal.blackoutDate": "This date is not available for reservations.",
  "amenities.modal.summary": "Cost Summary",
  "amenities.modal.rental": "Rental",
  "amenities.modal.deposit": "Deposit (Refundable)",
  "amenities.modal.total": "Total Due",
  "amenities.modal.confirm": "Confirm & Pay",

  "amenities.payment.generating": "Generating charge...",
  "amenities.payment.confirm_msg": "By confirming, a charge will be added to your account and will appear on your next statement.",

  "amenities.noRules": "No specific rules defined for this area.",
  "amenities.genericTerms": "By making this reservation, the user agrees to respect the area rules, keep the space in good condition, and accept responsibility for any damage caused during the booked period. Non-compliance may result in forfeiture of the deposit or future access restrictions.",

  "amenities.success": "Reservation confirmed successfully",

  // Admin
  "admin.title": "Administration Panel",
  "admin.section.community": "Community and Residents",
  "admin.section.finance": "Finances and Payments",
  "admin.section.security": "Security and Devices",
  "admin.section.platform": "Platform",

  "admin.card.users": "Residents",
  "admin.card.users.desc": "Manage profiles, tenants, and contracts.",
  "admin.card.residents": "Residents",
  "admin.card.residents.desc": "Manage residents, owners, and tenants.",
  "admin.card.staff": "Team",
  "admin.card.staff.desc": "Administrators, guards, and operational staff.",
  "admin.card.roles": "Roles",
  "admin.card.roles.desc": "Set up custom roles and permissions.",
  "admin.card.units": "Units",
  "admin.card.units.desc": "Configure towers, houses, and apartments.",
  "admin.card.amenities": "Amenities",
  "admin.card.amenities.desc": "Configure common areas, rules, and costs.",
  "admin.card.reservations": "Reservations",
  "admin.card.reservations.desc": "Occupancy calendar and charge report.",
  "admin.card.payments": "Billing",
  "admin.card.payments.desc": "Validate vouchers and issue invoices.",
  "admin.card.expenses": "Expenses",
  "admin.card.expenses.desc": "Control maintenance expenses.",
  "admin.card.access": "Access Points",
  "admin.card.access.desc": "Configure HikCentral, doors, and barriers.",
  "admin.card.lpr": "LPR Cameras",
  "admin.card.lpr.desc": "Manage vehicle whitelists and blacklists.",
  "admin.card.announcements": "Announcements",
  "admin.card.announcements.desc": "Publish news and urgent alerts.",
  "admin.card.settings": "Settings",
  "admin.card.settings.desc": "General rules, logos, and schedules.",

  "admin.users.table.name": "Name",
  "admin.users.table.unit": "Unit",
  "admin.users.table.role": "Role",
  "admin.users.table.status": "Status",
  "admin.users.role.owner": "Owner",
  "admin.users.role.tenant": "Tenant",

  // User Roles (for display)
  "roles.ADMIN": "Administrator",
  "roles.SECTION_ADMIN": "Section administrator",
  "roles.RESIDENT": "Resident",
  "roles.GUARD": "Guard",
  "roles.STAFF": "Staff",
  "roles.TENANT_USER": "User",
  "roles.FAMILIAR": "Household member",
  "roles.familiar": "Household member",
  "admin.users.btn.create": "New Resident",
  "admin.users.search": "Search by name, unit...",
  "admin.users.modal.title": "Resident's Data",
  "admin.users.modal.block": "Block Access",
  "admin.users.modal.unblock": "Unblock",
  "admin.users.viewAs": "View as",
  "impersonation.banner": "Viewing as {{name}} ({{role}})",
  "impersonation.exit": "Exit",
  "admin.users.status.active": "Active",
  "admin.users.status.blocked": "Blocked",
  "admin.users.status.pending": "Pending",

  // Admin Staff
  "admin.staff.title": "Work Team",
  "admin.staff.btn.create": "New Member",
  "admin.staff.empty": "There are no team members.",

  // Admin Roles
  "admin.roles.title": "Roles and Permissions",
  "admin.roles.btn.create": "New Role",
  "admin.roles.empty": "There are no custom roles.",
  "admin.roles.system": "System",
  "admin.roles.custom": "Custom",
  "admin.roles.permissions": "Permissions",

  // Admin Units
  "admin.units.title": "Unit Management",
  "admin.units.create": "New Unit",
  "admin.units.type": "Property Type",
  "admin.units.house": "Independent House",
  "admin.units.apt": "Apartment / Floor",
  "admin.units.unit_select": "Select Unit",
  "admin.units.allowed_devices.title": "Allowed doors",
  "admin.units.allowed_devices.button": "Doors",
  "admin.units.allowed_devices.description": "Define which doors this unit can open. Only the devices assigned here will be available to the residents and guests of this unit.",
  "admin.units.allowed_devices.assigned": "Assigned devices",
  "admin.units.allowed_devices.add_device": "Add device",
  "admin.units.allowed_devices.select_device": "Select a device...",
  "admin.units.allowed_devices.no_available": "No more devices available",
  "admin.units.allowed_devices.empty": "This unit has no doors assigned yet.",
  "admin.units.allowed_devices.added": "Device assigned",
  "admin.units.allowed_devices.already_assigned": "The device was already assigned",
  "admin.units.allowed_devices.removed": "Device removed",
  "admin.units.allowed_devices.remove": "Remove device",
  "admin.units.allowed_devices.load_error": "Failed to load devices",
  "admin.units.allowed_devices.add_error": "Failed to assign device",
  "admin.units.allowed_devices.remove_error": "Failed to remove device",

  // Admin Amenities
  "admin.amenities.title": "Amenity Management",
  "admin.amenities.create": "New Amenity",
  "admin.amenities.name": "Area Name",
  "admin.amenities.capacity": "Maximum Capacity",
  "admin.amenities.cost": "Cost per Hour",
  "admin.amenities.deposit": "Requires Deposit",
  "admin.amenities.deposit_amt": "Deposit Amount",
  "admin.amenities.min_hours": "Minimum Hours",
  "admin.amenities.max_hours": "Maximum Hours",
  "admin.amenities.image": "Cover Image",
  "admin.amenities.upload": "Upload Image",
  "admin.amenities.rules": "Usage Rules",
  "admin.amenities.terms": "Terms and Conditions",

  // Admin Reservations
  "admin.reservations.title": "Reservation Log",
  "admin.reservations.id": "Reservation ID",
  "admin.reservations.user": "User",
  "admin.reservations.refund_deposit": "Return Deposit",
  "admin.reservations.refunded": "Dep. Returned",

  // Admin Finance
  "admin.finance.title": "Financial Management",
  "admin.finance.generate_btn": "Generate Monthly Fees",
  "admin.finance.table.user": "Resident",
  "admin.finance.table.period": "Concept / Period",
  "admin.finance.table.amount": "Amount",
  "admin.finance.table.due": "Due Date",
  "admin.finance.table.status": "Status",
  "admin.finance.modal.title": "Generate Mass Maintenance",
  "admin.finance.modal.period": "Period (e.g., November 2023)",
  "admin.finance.modal.amount": "Standard Amount",
  "admin.finance.modal.due_date": "Payment Deadline",
  "admin.finance.modal.generate": "Generate Charges",
  "admin.finance.modal.success": "Charges generated successfully.",
  "admin.finance.register_pay": "Register Payment",
  "admin.finance.pay_modal.title": "Payment Registration",
  "admin.finance.pay_modal.method": "Payment Method",
  "admin.finance.pay_modal.ref": "Reference / Folio",
  "admin.finance.pay_modal.date": "Payment Date",
  "admin.finance.pay_modal.notes": "Comments",
  "admin.finance.pay_modal.methods.cash": "Cash",
  "admin.finance.pay_modal.methods.transfer": "Transfer / SPEI",
  "admin.finance.pay_modal.methods.card": "Credit/Debit Card",
  "admin.finance.pay_modal.methods.check": "Check",
  "admin.finance.filter.search": "Search resident...",
  "admin.finance.filter.all": "All statuses",
  "admin.finance.filter.paid": "Paid",
  "admin.finance.filter.pending": "Pending",
  "admin.finance.filter.overdue": "Overdue",
  "admin.finance.filter.verifying": "For Verification",

  // Admin Expenses
  "admin.expenses.title": "Expense Management",
  "admin.expenses.create": "Register Expense",
  "admin.expenses.table.concept": "Concept",
  "admin.expenses.table.provider": "Provider",
  "admin.expenses.table.category": "Category",
  "admin.expenses.table.amount": "Amount",
  "admin.expenses.table.date": "Date",
  "admin.expenses.modal.title": "New Expense",
  "admin.expenses.modal.desc": "Expense description",
  "admin.expenses.modal.category": "Accounting Category",
  "admin.expenses.modal.amount": "Total Amount",
  "admin.expenses.modal.provider": "Provider / Beneficiary",
  "admin.expenses.modal.date": "Expense Date",
  "admin.expenses.modal.receipt": "Attach Invoice/Receipt",
  "admin.expenses.cat.maintenance": "General Maintenance",
  "admin.expenses.cat.utilities": "Utilities (Electricity/Water/Gas)",
  "admin.expenses.cat.salaries": "Salaries",
  "admin.expenses.cat.cleaning": "Cleaning",
  "admin.expenses.cat.security": "Security",
  "admin.expenses.cat.insurance": "Insurance",
  "admin.expenses.cat.services": "Services",
  "admin.expenses.cat.payroll": "Payroll / Staff",
  "admin.expenses.cat.supplies": "Supplies",
  "admin.expenses.cat.refund": "Deposit Refund",
  "admin.expenses.cat.other": "Other",

  // Admin Charges
  "admin.charges.status.pending": "Pending",
  "admin.charges.status.partial": "Partial",
  "admin.charges.status.paid": "Paid",
  "admin.charges.status.cancelled": "Cancelled",
  "admin.charges.filter.allStatuses": "All",
  "admin.charges.filter.pending": "Pending",
  "admin.charges.filter.partial": "Partial",
  "admin.charges.filter.paid": "Paid",
  "admin.charges.filter.cancelled": "Cancelled",
  "admin.charges.filter.allTypes": "All types",
  "admin.charges.type.maintenance": "Maintenance",
  "admin.charges.type.fine": "Fine",
  "admin.charges.type.lateFee": "Late fee",
  "admin.charges.type.extra": "Extra",
  "admin.charges.type.service": "Service",
  "admin.charges.type.deposit": "Deposit",
  "admin.charges.type.other": "Other",

  // Payment methods
  "finance.method.cash": "Cash",
  "finance.method.transfer": "Transfer",
  "finance.method.card": "Card",
  "finance.method.check": "Check",

  // Admin Invoicing
  "admin.invoicing.title": "Billing and Reconciliation",
  "admin.invoicing.tab.verify": "Voucher Verification",
  "admin.invoicing.tab.emit": "Invoice Issuance",
  "admin.invoicing.verify.modal.title": "Validate Payment Voucher",
  "admin.invoicing.verify.approve": "Approve Payment",
  "admin.invoicing.verify.reject": "Reject Payment",
  "admin.invoicing.verify.reject_reason": "Reason for rejection",
  "admin.invoicing.emit.rfc": "Tax ID",
  "admin.invoicing.emit.btn": "Stamp Invoice",
  "admin.invoicing.emit.success": "Invoice stamped successfully",
  "admin.invoicing.emit.no_fiscal": "No fiscal data",
  "admin.invoicing.emit.invoiced": "Invoiced",
  "admin.invoicing.status.verifying": "Verifying",
  "admin.invoicing.proof": "Voucher",
  "admin.invoicing.download_xml": "XML",
  "admin.invoicing.download_pdf": "PDF",

  // Admin Devices
  "admin.devices.title": "Access Devices",
  "admin.devices.create": "New Device",
  "admin.devices.table.name": "Name / Location",
  "admin.devices.table.type": "Type",
  "admin.devices.table.ip": "IP Address",
  "admin.devices.table.status": "Status",
  "admin.devices.modal.title": "Configure Device",
  "admin.devices.type.pedestrian": "Pedestrian Door",
  "admin.devices.type.vehicle": "Vehicle Barrier",
  "admin.devices.type.controller": "Controller",
  "admin.devices.type.camera": "LPR Camera",
  "admin.devices.status.online": "Online",
  "admin.devices.status.offline": "Offline",

  // Admin LPR
  "admin.lpr.title": "LPR Cameras and Plates",
  "admin.lpr.tab.live": "Live Monitoring",
  "admin.lpr.tab.manage": "Plate Management",
  "admin.lpr.table.plate": "Plate",
  "admin.lpr.table.alias": "Owner / Alias",
  "admin.lpr.table.status": "Status",
  "admin.lpr.status.whitelist": "Whitelist",
  "admin.lpr.status.blacklist": "Blacklist",
  "admin.lpr.modal.title": "Register Plate",
  "admin.lpr.modal.plate": "Plate Number",
  "admin.lpr.modal.alias": "Name / Unit",
  "admin.lpr.modal.notes": "Notes (Reason for blocking)",
  "admin.lpr.live.camera": "Main Camera",
  "admin.lpr.live.last": "Last detection",

  // Admin Announcements
  "admin.ann.title": "Announcements and News",
  "admin.ann.create": "New Announcement",
  "admin.ann.modal.title": "Write News",
  "admin.ann.modal.title_field": "Announcement Title",
  "admin.ann.modal.content": "Content / Message",
  "admin.ann.modal.priority": "Announcement Type",
  "admin.ann.modal.expires": "Expiration Date",
  "admin.ann.modal.attach": "Attach File (PDF/IMG)",
  "admin.ann.modal.poll": "Create Poll",
  "admin.ann.modal.poll_q": "Poll question",
  "admin.ann.modal.poll_opt": "Options (One per line)",
  "admin.ann.modal.add_opt": "Add Option",

  "admin.ann.priority.urgent": "Urgent",
  "admin.ann.priority.important": "Important",
  "admin.ann.priority.info": "Informative",
  "admin.ann.priority.event": "Event",
  "admin.ann.vote_btn": "Vote",
  "admin.ann.votes": "votes",
  "admin.ann.attach_view": "View Attachment",

  // Admin Settings
  "admin.settings.title": "System Settings",
  "admin.settings.tab.general": "General",
  "admin.settings.tab.financial": "Financial",
  "admin.settings.tab.integrations": "Integrations",
  "admin.settings.section.identity": "Identity and Contact",
  "admin.settings.section.rules": "Business Rules",
  "admin.settings.section.security": "Security",
  "admin.settings.condo_name": "Condominium Name",
  "admin.settings.address": "Address",
  "admin.settings.contact_email": "Administration Email",
  "admin.settings.contact_phone": "Office Phone",
  "admin.settings.emergency_phone": "Emergency Phone",
  "admin.settings.website": "Website",
  "admin.settings.visitor_limit": "Active visitor limit per unit",
  "admin.settings.maintenance_fee": "Maintenance Fee (Default)",
  "admin.settings.currency": "Currency",
  "admin.settings.success": "Settings saved successfully.",

  "admin.settings.bank.title": "Bank Account (Deposits)",
  "admin.settings.bank.name": "Bank",
  "admin.settings.bank.account": "Account Holder Name",
  "admin.settings.bank.number": "Account No.",
  "admin.settings.bank.clabe": "Interbank CLABE",

  "admin.settings.fiscal.title": "Fiscal Data (Issuer)",
  "admin.settings.fiscal.rfc": "Issuer Tax ID",
  "admin.settings.fiscal.name": "Business Name",
  "admin.settings.fiscal.regime": "Fiscal Regime",
  "admin.settings.fiscal.zip": "Postal Code",

  // Integration Marketplace
  "admin.settings.integrations.title": "Integration Marketplace",
  "admin.settings.integrations.desc": "Connect your favorite apps to automate processes.",
  "admin.settings.integrations.category.all": "All",
  "admin.settings.integrations.category.access": "Access and Security",
  "admin.settings.integrations.category.payment": "Online Payments",
  "admin.settings.integrations.category.comm": "Communication",
  "admin.settings.integrations.category.cloud": "Cloud and Services",
  "admin.settings.integrations.status.connected": "Connected",
  "admin.settings.integrations.status.disconnected": "Disconnected",
  "admin.settings.integrations.btn.connect": "Connect",
  "admin.settings.integrations.btn.configure": "Configure",
  "admin.settings.integrations.modal.title": "Integration Settings",
  "admin.settings.integrations.modal.enable": "Enable service",
  "admin.settings.integrations.key": "API Key / Token",
  "admin.settings.integrations.secret": "Secret Key",
  "admin.settings.integrations.url": "Server URL",

  "admin.settings.integrations.hik": "HikCentral",
  "admin.settings.integrations.hik.desc": "Hikvision's centralized security platform.",
  "admin.settings.integrations.hikCentral": "HikCentral",
  "admin.settings.integrations.hikCentral.desc": "Hikvision's centralized security platform.",
  "admin.settings.integrations.dahua": "Dahua DSS",
  "admin.settings.integrations.dahua.desc": "Dahua video surveillance and access control management.",
  "admin.settings.integrations.zkteco": "ZKTeco BioSecurity",
  "admin.settings.integrations.zkteco.desc": "Biometric access control and attendance.",

  "admin.settings.integrations.stripe": "Stripe",
  "admin.settings.integrations.stripe.desc": "International credit/debit card payments.",
  "admin.settings.integrations.mercadopago": "MercadoPago",
  "admin.settings.integrations.mercadopago.desc": "Leading payment gateway in Latin America.",
  "admin.settings.integrations.conekta": "Conekta",
  "admin.settings.integrations.conekta.desc": "Cash payments (OXXO Pay) and transfers.",

  "admin.settings.integrations.whatsapp": "WhatsApp API",
  "admin.settings.integrations.whatsapp.desc": "Sending QR codes and official notifications (Meta).",
  "admin.settings.integrations.twilio": "Twilio SMS",
  "admin.settings.integrations.twilio.desc": "Programmable SMS and voice messaging.",
  "admin.settings.integrations.smtp": "SMTP Server",
  "admin.settings.integrations.smtp.desc": "Custom email configuration.",

  "admin.settings.integrations.aws": "AWS S3",
  "admin.settings.integrations.aws.desc": "Secure storage for documents and evidence.",

  // Integration Catalog
  "admin.settings.integrations.test": "Test Connection",
  "admin.settings.integrations.test.success": "Connection successful ({time}ms)",
  "admin.settings.integrations.test.failed": "Connection failed: {error}",
  "admin.settings.integrations.testing": "Testing...",
  "admin.settings.integrations.configured": "Configured",
  "admin.settings.integrations.notConfigured": "Not configured",
  "admin.settings.integrations.saving": "Saving...",
  "admin.settings.integrations.saved": "Configuration saved",
  "admin.settings.integrations.errorSaving": "Error saving configuration",
  "admin.settings.integrations.errorLoading": "Error loading integrations",
  "admin.settings.integrations.lastUsed": "Last used",
  "admin.settings.integrations.errors": "errors",
  "admin.settings.integrations.showOptional": "Show optional fields",
  "admin.settings.integrations.hideOptional": "Hide optional fields",

  // Tickets
  "tickets.title": "Reports & Incidents",
  "tickets.create": "New Report",
  "tickets.empty": "No reports registered.",
  "tickets.status.new": "New",
  "tickets.status.in_review": "In Review",
  "tickets.status.in_process": "In Process",
  "tickets.status.resolved": "Resolved",
  "tickets.category.leak": "Water Leak",
  "tickets.category.lighting": "Lighting",
  "tickets.category.security": "Security",
  "tickets.category.complaint": "Complaint / Noise",
  "tickets.category.lost_pet": "Lost Pet",
  "tickets.category.other": "Other",
  "tickets.modal.title": "Create Report",
  "tickets.modal.subject": "Problem subject",
  "tickets.modal.desc": "Detailed description",
  "tickets.modal.category": "Incident Type",
  "tickets.modal.photo": "Photo / Evidence",
  "tickets.detail.title": "Report Details",
  "tickets.chat.placeholder": "Type a message...",
  "tickets.reportedBy": "Reported by",
  "tickets.chat.send": "Send",
  "tickets.admin.status_change": "Update Status",

  // Payments Resident
  "payments.title": "Payments and Maintenance",
  "payments.balance": "Total Balance to Pay",
  "payments.pay_total": "Pay in Full",
  "payments.history": "Payment History",
  "payments.table.period": "Period",
  "payments.table.due": "Due Date",
  "payments.table.amount": "Amount",
  "payments.table.status": "Status",
  "payments.table.actions": "Actions",
  "payments.status.paid": "Paid",
  "payments.status.pending": "Pending",
  "payments.status.overdue": "Overdue",
  "payments.status.verifying": "Verifying",
  "payments.btn.pay": "Pay Now",
  "payments.btn.invoice": "Invoice",
  "payments.modal.title": "Make Payment",
  "payments.modal.amount": "Amount to Pay",
  "payments.modal.tab.card": "Credit/Debit Card",
  "payments.modal.tab.transfer": "SPEI Transfer",
  "payments.modal.card.holder": "Cardholder's Name",
  "payments.modal.card.number": "Card Number",
  "payments.modal.card.exp": "Expiration",
  "payments.modal.card.cvv": "CVV",
  "payments.modal.transfer.bank": "Bank",
  "payments.modal.transfer.beneficiary": "Beneficiary",
  "payments.modal.transfer.clabe": "Interbank CLABE",
  "payments.modal.transfer.upload": "Upload Voucher",
  "payments.modal.transfer.ref": "Reference / Folio",
  "payments.modal.success_card": "Payment processed successfully.",
  "payments.modal.success_transfer": "Voucher sent for review.",
  "payments.pendingCharges": "Pending charges",
  "payments.paymentHistory": "Payment history",
  "payments.historyEmpty": "No payments in history",
  "payments.downloadInvoice": "Download Invoice",
  "payments.amount": "Amount",
  "payments.dueDate": "Due date",
  "payments.status": "Status",
  "payments.uploadReceipt": "Upload Voucher",
  "payments.paymentMethod": "Payment Method",
  "payments.paymentReceipt": "Payment Voucher",
  "payments.selectFile": "Select file",
  "payments.reference": "Reference",
  "payments.folio": "Folio",
  "payments.notes": "Notes",
  "payments.notesPlaceholder": "Additional information...",
  "payments.cancel": "Cancel",
  "payments.sendProof": "Send Voucher",
  "payments.noPendingCharges": "No pending charges",
  "payments.selectedFile": "File selected",
  "payments.referencePlaceholder": "Reference or Folio",
  "payments.chargesToPay": "Charges to Pay",
  "payments.total": "Total",
  "payments.bankInfo": "Bank Information",
  "payments.bank": "Bank",
  "payments.beneficiary": "Beneficiary",
  "payments.clabe": "CLABE",
  "payments.transfer": "Transfer",
  "payments.cash": "Cash",
  "payments.check": "Check",
  "payments.na": "N/A",
  "payments.rejectionReason": "Reason for rejection",
  "payments.pending": "Pending",
  "payments.overdue": "Overdue",
  "payments.date": "Date",
  "payments.method": "Method",
  "payments.concept": "Concept",
  "payments.de": "of",
  "payments.noPaymentHistory": "No payment history.",
  "payments.paySelected": "Pay Selected",
  "payments.upToDateWithPayments": "You are up to date with your payments",
  "payments.overdueCount": "Overdue charges",
  "payments.outstandingBalance": "Outstanding balance",
  "dashboard.upcomingReservations": "Upcoming reservations",
  "payments.pendingCount": "Pending charges",
  "payments.currentBalance": "Current balance",
  "payments.totalCharges": "Total charges",
  "payments.totalPayments": "Total payments",
  "payments.overdueAmount": "Overdue amount",
  "payments.card": "Card",

  // Common
  "common.copied": "Copied",
  "common.delete": "Delete",
  "common.edit": "Edit",
  "common.share": "Share",
  "common.close": "Close",
  "common.save": "Save",
  "common.back": "Back",
  "common.error": "An error occurred",
  "common.loading": "Loading...",
  "common.email": "Email",
  "common.phone": "Phone",
  "common.tower": "Tower",
  "common.unit": "Unit / No.",
  "common.role": "Role",
  "common.street": "Street",
  "common.block": "Block",
  "common.floor": "Floor",
  "common.ext_num": "Ext. No.",
  "common.int_num": "Int. No.",
  "common.show": "Show",
  "common.hide": "Hide",

  // Residential switch (each tenant is a separate account with its own password)
  "tenantSwitch.subtitle": "Residential Panel",
  "tenantSwitch.title": "Switch residential",
  "tenantSwitch.description": "Each residential has its own account. Enter the password for {tenant} to continue.",
  "tenantSwitch.passwordLabel": "Password for that residential",
  "tenantSwitch.confirm": "Enter",
  "tenantSwitch.error": "Could not switch residential",
  "common.cancel": "Cancel",
  "common.all": "All",
  "common.confirm": "Confirm",
  "common.create": "Create",
  "common.add": "Add",
  "common.description": "Description",
  "common.notes": "Notes",
  "common.select": "Select",
  "common.more": "more",
  "common.viewAll": "View all",
  "common.previous": "Previous",
  "common.next": "Next",
  "common.inactive": "Inactive",
  "common.optional": "Optional",
  "common.required": "Required",
  "common.name": "Name",
  "common.location": "Location",
  "common.title": "Title",
  "common.titlePlaceholder": "E.g. Elevator incident",
  "common.descriptionPlaceholder": "E.g. The elevator is not working properly",
  "common.locationPlaceholder": "E.g. Tower 1, Floor 1, Unit 1",
  "common.photoPlaceholder": "Photo of the incident",
  "common.photoUpload": "Upload photo",
  "common.photoRemove": "Remove photo",
  "common.photoPreview": "Photo preview",
  "common.photoError": "Error uploading photo",
  "common.photoSuccess": "Photo uploaded successfully",
  "common.filter": "Filter",
  "common.filterPlaceholder": "Search...",
  "common.filterBy": "Filter by",
  "common.filterByPlaceholder": "Search...",
  "common.filterByValue": "Search...",
  "common.filterByValuePlaceholder": "Search...",
  "common.filterByValueValue": "Search...",
  "common.address": "Address",
  "common.savedSuccessfully": "Saved successfully",

  // Tickets
  "tickets.no_results": "No reports with this filter",

  // Notifications
  "notifications.title": "Notifications",
  "notifications.empty": "You have no notifications",
  "notifications.noNotifications": "Notifications will appear here",
  "notifications.markAllRead": "Mark all as read",
  "notifications.viewAll": "View all notifications",
  "notifications.markedAsRead": "Notification marked as read",
  "notifications.allMarkedAsRead": "All notifications marked as read",
  "notifications.errorLoading": "Error loading notifications",
  "notifications.errorMarkingRead": "Error marking as read",
  "notifications.errorMarkingAllRead": "Error marking all as read",
  "notifications.errorNavigating": "Unable to open that notification",
  "notifications.unreadCount": "{count} unread",
  "notifications.allRead": "You have no unread notifications",
  "notifications.filterAll": "All",
  "notifications.filterUnread": "Unread",
  "notifications.filterRead": "Read",
  "notifications.tryDifferentFilter": "Try another filter",
  "notifications.channelAll": "All",
  "notifications.channelInApp": "In App",
  "notifications.channelEmail": "Email",
  "notifications.channelPush": "Push",
  "notifications.preferences": "Notification preferences",
  "notifications.preferences.push": "Push Notifications",
  "notifications.preferences.email": "Email",
  "notifications.preferences.sms": "SMS",
  "notifications.preferences.whatsapp": "WhatsApp",
  "notifications.preferences.inApp": "In-app",
  "notifications.preferences.quietHours": "Quiet hours",
  "notifications.preferences.quietStart": "Start time",
  "notifications.preferences.quietEnd": "End time",
  "notifications.preferences.emailDigest": "Email digest",
  "notifications.preferences.emailDigest.off": "Off",
  "notifications.preferences.emailDigest.daily": "Daily",
  "notifications.preferences.emailDigest.weekly": "Weekly",
  "notifications.preferences.saved": "Preferences saved",
  "notifications.send": "Send notification",
  "notifications.sendBulk": "Bulk send",

  // Polls
  "polls.title": "Polls",
  "polls.empty": "No active polls",
  "announcements.empty": "No announcements",
  "polls.vote": "Vote",
  "polls.voted": "You have already voted",
  "polls.closed": "Poll closed",
  "polls.results": "Results",
  "polls.ends": "Ends",
  "polls.totalVotes": "total votes",
  "polls.selectOption": "Select an option",
  "polls.selectOptions": "Select one or more options",
  "polls.voting": "Voting...",
  "polls.voteSuccess": "Vote registered successfully",
  "polls.status.draft": "Draft",
  "polls.status.active": "Active",
  "polls.status.closed": "Closed",
  "polls.admin.title": "Poll Management",
  "polls.admin.create": "New Poll",
  "polls.admin.createAgain": "Create poll again",
  "polls.admin.publish": "Publish",
  "polls.admin.close": "Close",
  "polls.admin.recreate": "Recreate Poll",
  "polls.admin.delete": "Delete",
  "polls.admin.viewResults": "View Results",
  "polls.admin.published": "Poll published",
  "polls.admin.closed": "Poll closed",
  "polls.admin.deleted": "Poll deleted",
  "polls.form.title": "Poll title",
  "polls.form.description": "Description (optional)",
  "polls.form.options": "Options",
  "polls.form.addOption": "Add option",
  "polls.form.allowMultiple": "Allow multiple answers",
  "polls.form.isAnonymous": "Anonymous voting",
  "polls.form.startsAt": "Start date",
  "polls.form.endsAt": "End date",
  "polls.form.minOptions": "At least 2 options are required",
  "polls.changeVote": "Change vote",
  "polls.changeVoteConfirm.title": "Change vote",
  "polls.changeVoteConfirm.message": "Are you sure you want to change your vote? Your previous vote will be replaced.",
  "polls.changeVoteConfirm.confirm": "Yes, change",
  "polls.tabs.active": "Active",
  "polls.tabs.closed": "Closed",
  "polls.emptyClosed": "No closed polls",
  "polls.participation": "of",
  "polls.participationUnits": "units",
  "polls.selectUnit": "Select unit to vote",
  "polls.selectUnitPlaceholder": "Select your unit...",
  "polls.votingAsUnit": "Voting as unit",
  "polls.detailedVotes": "Vote details",
  "polls.detailedVotes.voter": "Voter",
  "polls.detailedVotes.option": "Option",
  "polls.detailedVotes.unit": "Unit",
  "polls.detailedVotes.date": "Date",
  "polls.detailedVotes.empty": "No detailed votes available",
  "polls.detailedVotes.anonymous": "This poll is anonymous. Individual votes are not shown.",
  "polls.error.onlyTitulares": "Only unit owners can vote in this poll",
  "polls.error.unitRequired": "You must select a unit to vote",
  "polls.error.unitNotBelongsToUser": "The selected unit does not belong to you",
  "polls.error.pollNotActive": "This poll is no longer active",
  "polls.error.pollNotFound": "Poll not found",
  "polls.error.generic": "An error occurred while voting",
  "poll.admin.publish.message": "Are you sure you want to publish ",
  "poll.admin.close.message": "Are you sure you want to close ",
  "poll.admin.edit.message": "Are you sure you want to edit ",

  // Settings
  "settings.title": "Settings",
  "settings.language": "Language",
  "settings.theme": "Theme",
  "settings.darkMode": "Dark Mode",
  "settings.lightMode": "Light Mode",
  "settings.systemDefault": "System Default",
  "settings.about": "About",
  "settings.version": "Version",
  "settings.termsOfService": "Terms of Service",
  "settings.privacyPolicy": "Privacy Policy",
  "settings.preferences": "Preferences",
  "settings.support": "Support",
  "settings.help": "Help",
  "settings.contactAdmin": "Contact Administration",
  "settings.terms": "Terms of Service",
  "settings.privacy": "Privacy",
  "settings.security": "Security",

  // Household Members
  "household.title": "Household Members",
  "household.addMember": "Add Member",
  "household.editMember": "Edit Member",
  "household.deleteMember": "Delete Member",
  "household.empty": "No household members registered",
  "household.emailRequired": "Email is required to create an account",
  "household.emailHint": "An access link will be sent to this email",
  "household.name": "Full name",
  "household.relation": "Relationship",
  "household.email": "Email",
  "household.phone": "Phone",
  "household.age": "Age",
  "household.relations.spouse": "Spouse",
  "household.relations.child": "Child",
  "household.relations.parent": "Parent",
  "household.relations.other": "Other",
  "household.accountStatus": "Account status",
  "household.status.pending": "Pending",
  "household.status.active": "Active",
  "household.status.inactive": "Inactive",
  "household.inviteSent": "Invitation sent to {email}",
  "household.resendInvite": "Resend invitation",
  "household.resendSuccess": "Invitation resent successfully",
  "household.deleteConfirm": "Are you sure you want to delete this household member?",

  // Magic Link
  "magicLink.title": "Verify your account",
  "magicLink.verifying": "Verifying...",
  "magicLink.success": "Account verified successfully!",
  "magicLink.error": "Error verifying",
  "magicLink.expired": "This link has expired",
  "magicLink.invalid": "Invalid link",
  "magicLink.alreadyUsed": "This link has already been used",
  "magicLink.requestNew": "Request new link",
  "magicLink.requestNewTitle": "Request access",
  "magicLink.enterEmail": "Enter your email",
  "magicLink.emailSent": "A new link has been sent to your email",
  "magicLink.selectTenant": "Select your residential",
  "magicLink.selectTenantSubtitle": "You have access to multiple residentials",

  // Onboarding
  "onboarding.welcome": "Welcome to Yawi!",
  "onboarding.welcomeSubtitle": "Your access to the community",
  "onboarding.familiarRole": "You have been added as a household member",
  "onboarding.whatYouCanDo": "This is what you can do:",
  "onboarding.features.guests": "Manage guests",
  "onboarding.features.guestsDesc": "Create and manage access codes for your visitors",
  "onboarding.features.announcements": "View announcements",
  "onboarding.features.announcementsDesc": "Stay informed about community news",
  "onboarding.features.polls": "Participate in polls",
  "onboarding.features.pollsDesc": "Vote in community polls",
  "onboarding.features.accessLogs": "Access history",
  "onboarding.features.accessLogsDesc": "Check the log of entries and exits",
  "onboarding.continue": "Continue",
  "onboarding.letsStart": "Let's start!",

  // Forgot Password
  "forgotPassword.title": "Recover password",
  "forgotPassword.subtitle": "Enter your email and we will send you instructions",
  "forgotPassword.email": "Email",
  "forgotPassword.submit": "Send instructions",
  "forgotPassword.sending": "Sending...",
  "forgotPassword.success": "Check your email",
  "forgotPassword.successMessage": "If the email exists, you will receive instructions to reset your password.",
  "forgotPassword.backToLogin": "Back to login",

  // Reset Password
  "resetPassword.title": "New password",
  "resetPassword.subtitle": "Enter your new password",
  "resetPassword.newPassword": "New password",
  "resetPassword.confirmPassword": "Confirm password",
  "resetPassword.submit": "Change password",
  "resetPassword.submitting": "Changing...",
  "resetPassword.success": "Password updated",
  "resetPassword.successMessage": "Your password has been updated. You can now log in.",
  "resetPassword.requirements": "Minimum 8 characters, one uppercase, one lowercase, and one number",
  "resetPassword.passwordMismatch": "Passwords do not match",
  "resetPassword.invalidToken": "The link is invalid or has expired",
  "resetPassword.requestNew": "Request new link",
  "resetPassword.goToLogin": "Go to log in",

  // Logbook
  "logbook.title": "Guard's Logbook",
  "logbook.createEntry": "New Entry",
  "logbook.shiftHandover": "Shift Change",
  "logbook.noEntries": "No entries registered",
  "logbook.type.incident": "Incident",
  "logbook.type.observation": "Observation",
  "logbook.type.delivery": "Package",
  "logbook.type.maintenance": "Maintenance",
  "logbook.type.visitor": "Visitor",
  "logbook.type.other": "Other",
  "logbook.priority.low": "Low",
  "logbook.priority.medium": "Medium",
  "logbook.priority.high": "High",
  "logbook.priority.critical": "Critical",
  "logbook.entryTitle": "Title",
  "logbook.entryDescription": "Description",
  "logbook.entryLocation": "Location",
  "logbook.entryCreated": "Entry registered",
  "logbook.newEntry": "New Entry",
  "logbook.searchPlaceholder": "Search entries...",
  "logbook.type.label": "Type",
  "logbook.priority.label": "Priority",

  "notification.priority.low": "Low",
  "notification.priority.normal": "Normal",
  "notification.priority.high": "High",
  "notification.priority.urgent": "Urgent",
  "logbook.entryUpdated": "Entry updated",
  "logbook.entryDeleted": "Entry deleted",
  "logbook.entryViewed": "Entry viewed",
  "logbook.entryEdited": "Entry edited",
  "logbook.entryType": "Entry type",
  "logbook.type.novedad": "Entry",
  "logbook.type.incidente": "Incident",
  "logbook.type.observacion": "Observation",
  "logbook.type.paqueteria": "Package",
  "logbook.type.mantenimiento": "Maintenance",
  "logbook.type.visitante": "Visitor",
  "logbook.type.otro": "Other",
  "logbook.titlePlaceholder": "e.g. Incident in the elevator",
  "logbook.descriptionPlaceholder": "e.g. The elevator is not working correctly",
  "logbook.locationPlaceholder": "e.g. Tower 1, Floor 1, Unit 1",
  "logbook.photoPlaceholder": "Photo of the entry",
  "logbook.photoUpload": "Upload photo",
  "logbook.photoRemove": "Delete photo",
  "logbook.photoPreview": "Photo preview",
  "logbook.photoError": "Error uploading photo",
  "logbook.photoSuccess": "Photo uploaded successfully",

  // Patrol
  "patrol.rounds": "Rounds",
  "patrol.checkpoints": "Checkpoints",
  "patrol.startRound": "Start Round",
  "patrol.completeRound": "End Round",
  "patrol.scanCheckpoint": "Scan Point",
  "patrol.noRounds": "No rounds registered",
  "patrol.noCheckpoints": "No checkpoints",
  "patrol.createCheckpoint": "Create Point",
  "patrol.checkpointName": "Point Name",
  "patrol.checkpointLocation": "Location",
  "patrol.status.in_progress": "In Progress",
  "patrol.status.completed": "Completed",
  "patrol.status.incomplete": "Incomplete",
  "patrol.roundStarted": "Round started",
  "patrol.roundCompleted": "Round completed",
  "patrol.checkpointScanned": "Point scanned",
  "patrol.progress": "Progress",
  "patrol.scannedAt": "Scanned",
  "patrol.title": "Patrol",
  "patrol.roundsHistory": "Rounds History",
  "patrol.newCheckpoint": "New Point",
  "patrol.totalCheckpoints": "Total Points",
  "patrol.activeCheckpoints": "Active Points",
  "patrol.checkpointNamePlaceholder": "e.g. Checkpoint 1",
  "patrol.checkpointLocationPlaceholder": "e.g. Tower 1, Floor 1, Unit 1",
  "patrol.checkpointDescriptionPlaceholder": "e.g. Checkpoint for tower 1",
  "patrol.checkpointPhotoPlaceholder": "Photo of the checkpoint",
  "patrol.checkpointPhotoUpload": "Upload photo",
  "patrol.checkpointPhotoRemove": "Delete photo",
  "patrol.checkpointPhotoPreview": "Photo preview",
  "patrol.checkpointPhotoError": "Error uploading photo",
  "patrol.checkpointPhotoSuccess": "Photo uploaded successfully",
  "patrol.locationPlaceholder": "e.g. Tower 1, Floor 1, Unit 1",
  "patrol.descriptionPlaceholder": "e.g. Checkpoint for tower 1",
  "patrol.orderIndex": "Index",
  "patrol.orderIndexPlaceholder": "1",
  "patrol.orderIndexRequired": "Index is required",
  "patrol.orderIndexMin": "Index must be greater than 0",
  "patrol.orderIndexMax": "Index must be less than 1000",
  "patrol.orderIndexStep": "1",
  "patrol.orderIndexStepPlaceholder": "1",
  "patrol.gpsCoordinates": "GPS Coordinates",
  "patrol.gpsCoordinatesPlaceholder": "e.g. 19.432834, -99.123456",
  "patrol.gpsCoordinatesRequired": "GPS coordinates are required",
  "patrol.gpsCoordinatesMin": "GPS coordinates must be greater than 0",
  "patrol.gpsCoordinatesMax": "GPS coordinates must be less than 1000",
  "patrol.gpsCoordinatesStep": "1",
  "patrol.gpsCoordinatesStepPlaceholder": "1",
  "patrol.gpsCoordinatesSuccess": "GPS coordinates registered successfully",
  "patrol.latitude": "Latitude",
  "patrol.longitude": "Longitude",
  "patrol.latitudePlaceholder": "e.g. 19.432834",
  "patrol.longitudePlaceholder": "e.g. -99.123456",
  "patrol.latitudeRequired": "Latitude is required",
  "patrol.longitudeRequired": "Longitude is required",
  "patrol.latitudeMin": "Latitude must be greater than 0",
  "patrol.longitudeMax": "Longitude must be less than 1000",
  "patrol.filterByStatus": "Filter by status",
  "patrol.status.pending": "Pending",
  "patrol.currentRound": "Current round",
  "patrol.autoAssigned": "Auto assigned",
  "patrol.downloadQR": "Download QR",
  "patrol.editCheckpoint": "Edit Checkpoint",
  "patrol.useCurrentLocation": "Use current location",

  // Suppliers
  "suppliers.title": "Suppliers",
  "suppliers.directory": "Directory",
  "suppliers.visits": "Visits",
  "suppliers.create": "New Supplier",
  "suppliers.edit": "Edit Supplier",
  "suppliers.noSuppliers": "No suppliers registered",
  "suppliers.noVisits": "No visits registered",
  "suppliers.searchPlaceholder": "Search suppliers...",
  "suppliers.category.label": "Category",
  "suppliers.category.plomeria": "Plumbing",
  "suppliers.category.electricidad": "Electricity",
  "suppliers.category.jardineria": "Gardening",
  "suppliers.category.limpieza": "Cleaning",
  "suppliers.category.mantenimiento": "Maintenance",
  "suppliers.category.seguridad": "Security",
  "suppliers.category.fumigacion": "Fumigation",
  "suppliers.category.mudanzas": "Moving",
  "suppliers.category.reparaciones": "Repairs",
  "suppliers.category.cerrajeria": "Locksmithing",
  "suppliers.category.pintura": "Painting",
  "suppliers.category.carpinteria": "Carpentry",
  "suppliers.category.aire_acondicionado": "Air Conditioning",
  "suppliers.category.albercas": "Pools",
  "suppliers.category.impermeabilizacion": "Waterproofing",
  "suppliers.category.otro": "Other",
  "suppliers.created": "Supplier created",
  "suppliers.checkIn": "Register Entry",
  "suppliers.checkOut": "Register Exit",
  "suppliers.checkedIn": "Inside",
  "suppliers.checkedOut": "Finished",
  "suppliers.visitPurpose": "Purpose of visit",
  "suppliers.visitPurposePlaceholder": "e.g. Garden maintenance",
  "suppliers.authorizedBy": "Authorized by",
  "suppliers.authorizedByPlaceholder": "Resident's name",
  "suppliers.vehiclePlate": "Vehicle plate",
  "suppliers.registerEntry": "Register Entry",
  "suppliers.visitRegistered": "Visit registered",
  "suppliers.checkoutSuccess": "Exit registered",
  "suppliers.registerVisitFor": "Register visit from:",
  "suppliers.activeVisits": "Active Visits",
  "suppliers.completedVisits": "Completed Visits",
  "suppliers.destinationUnit": "Destination unit",
  "suppliers.rate": "Rate",
  "suppliers.enterRating": "Enter rating (1-5):",
  "suppliers.ratingSuccess": "Rating registered",
  "suppliers.contactName": "Contact name",
  "suppliers.contactInfo": "Contact information",

  // Inventory
  "inventory.assets": "Fixed Assets",
  "inventory.consumables": "Consumables",
  "inventory.createAsset": "New Asset",
  "inventory.editAsset": "Edit Asset",
  "inventory.createConsumable": "New Consumable",
  "inventory.editConsumable": "Edit Consumable",
  "inventory.noAssets": "No assets registered",
  "inventory.noConsumables": "No consumables registered",
  "inventory.searchAssets": "Search assets...",
  "inventory.searchConsumables": "Search consumables...",
  "inventory.assetName": "Asset name",
  "inventory.assetCode": "Code",
  "inventory.consumableName": "Consumable name",
  "inventory.consumableCode": "Code",
  "inventory.category": "Category",
  "inventory.brand": "Brand",
  "inventory.model": "Model",
  "inventory.serialNumber": "Serial number",
  "inventory.location": "Location",
  "inventory.locationPlaceholder": "e.g. Main warehouse, Booth 1",
  "inventory.purchaseDate": "Purchase date",
  "inventory.purchaseValue": "Purchase value",
  "inventory.currentValue": "Current value",
  "inventory.maintenanceInterval": "Maintenance interval (days)",
  "inventory.days": "days",
  "inventory.status": "Status",
  "inventory.status.active": "Active",
  "inventory.status.maintenance": "In Maintenance",
  "inventory.status.retired": "Decommissioned",
  "inventory.status.lost": "Lost",
  "inventory.maintenanceDue": "Maintenance required",
  "inventory.maintenanceDueWarning": "Assets with pending maintenance",
  "inventory.nextMaintenance": "Next maintenance",
  "inventory.generateQR": "Generate QR",
  "inventory.assetCreated": "Asset created",
  "inventory.consumableCreated": "Consumable created",
  "inventory.showMaintenanceDueOnly": "Only with pending maintenance",
  "inventory.registerMaintenance": "Register Maintenance",
  "inventory.maintenanceType": "Type of maintenance",
  "inventory.maintenanceDescription": "Work description",
  "inventory.maintenanceDescriptionPlaceholder": "e.g. Filter change, lubrication",
  "inventory.performedBy": "Performed by",
  "inventory.technicianName": "Technician's name",
  "inventory.performedAt": "Date of completion",
  "inventory.maintenanceCost": "Cost",
  "inventory.nextMaintenanceAt": "Next maintenance",
  "inventory.maintenanceCreated": "Maintenance registered",
  "inventory.unit": "Unit of measurement",
  "inventory.minimumStock": "Minimum stock",
  "inventory.maximumStock": "Maximum stock",
  "inventory.unitCost": "Unit cost",
  "inventory.currentStock": "Current stock",
  "inventory.min": "Min",
  "inventory.max": "Max",
  "inventory.lowStock": "Low stock",
  "inventory.lowStockWarning": "Consumables with low stock",
  "inventory.showLowStockOnly": "Only with low stock",
  "inventory.stockIn": "Entry",
  "inventory.stockOut": "Exit",
  "inventory.stockAdjustment": "Adjustment",
  "inventory.quantity": "Quantity",
  "inventory.newStock": "New stock",
  "inventory.projectedStock": "Projected stock",
  "inventory.reason": "Reason",
  "inventory.reasonPlaceholder": "e.g. Monthly purchase, use for maintenance",
  "inventory.referenceNumber": "Reference number",
  "inventory.referencePlaceholder": "e.g. Invoice, purchase order",
  "inventory.stockInSuccess": "Entry registered",
  "inventory.stockOutSuccess": "Exit registered",

  // Reports
  "reports.title": "Reports",
  "reports.accountStatement.title": "Account Statement",
  "reports.delinquent.title": "Delinquent Report",
  "reports.annualBilling.title": "Annual Billing Table",
  "reports.incomeExpense.title": "Income and Expenses",
  "reports.monthlyStatement.title": "Monthly Financial Statement",
  "reports.monthlyStatement.description": "Monthly financial information: income and expenses with detail and balance summary",
  "reports.journal.title": "General Journal (Debit & Credit)",
  "reports.journal.description": "Monthly movements in accounting Debit/Credit format with a running balance",
  "reports.bankReconciliation.title": "Bank Reconciliation",
  "reports.bankReconciliation.description": "Compare the book balance against the bank statement and mark reconciled movements",
  "reports.admin.title": "Admin",
  "reports.resident.title": "Your Account Statement",
  "reports.resident.description": "Here you can consult all your charges and payments, filter by date, and export your account statement in different formats.",
  "reports.admin.description": "Generate and export the condominium's financial reports.",
  "reports.accountStatement.description": "Consult your account statement with all charges and payments",
  "reports.delinquent.description": "List of units with overdue charges and amounts owed",
  "reports.annualBilling.description": "Monthly view of collections per unit with payment status",
  "reports.incomeExpense.description": "Cash flow with annual comparison and breakdown by category",

  // Access Logs
  "accessLogs.title": "Access Log",
  "accessLogs.subtitle": "History of entries and exits from the condominium",
  "accessLogs.create": "Register Access",
  "accessLogs.registerAccess": "Register Access",
  "accessLogs.noRecords": "No access records",
  "accessLogs.searchPlaceholder": "Search by name, plate...",
  "accessLogs.accessType": "Access Type",
  "accessLogs.accessMethod": "Method",
  "accessLogs.personTypeLabel": "Person Type",
  "accessLogs.person": "Person",
  "accessLogs.details": "Method / details",
  "accessLogs.registeredBy": "Registered by",
  "accessLogs.timestamp": "Date/Time",
  "accessLogs.unit": "Unit",
  "accessLogs.type.entry": "Entry",
  "accessLogs.type.exit": "Exit",
  "accessLogs.method.manual": "Manual",
  "accessLogs.method.qr": "QR Code",
  "accessLogs.method.rfid": "RFID Card",
  "accessLogs.method.facial": "Facial Recognition",
  "accessLogs.method.plate": "Plate Reading",
  "accessLogs.personType.resident": "Resident",
  "accessLogs.personType.visitor": "Visitor",
  "accessLogs.personType.delivery": "Delivery",
  "accessLogs.personType.service": "Service",
  "accessLogs.personType.employee": "Employee",
  "accessLogs.personName": "Name",
  "accessLogs.personNamePlaceholder": "Full name",
  "accessLogs.personDocument": "Document/ID",
  "accessLogs.personDocumentPlaceholder": "ID, Passport, etc.",
  "accessLogs.vehiclePlate": "Vehicle Plate",
  "accessLogs.vehiclePlatePlaceholder": "e.g. ABC-123",
  "accessLogs.selectUnit": "Select Unit",
  "accessLogs.notes": "Notes",
  "accessLogs.notesPlaceholder": "Additional observations...",
  "accessLogs.status": "Status",
  "accessLogs.personSearch": "Person",
  "accessLogs.personSearchPlaceholder": "Search by name",
  "accessLogs.detailSearch": "Details",
  "accessLogs.detailSearchPlaceholder": "Search detail or reason",
  "accessLogs.date": "Date",
  "accessLogs.entryPoint": "Entry Point",
  "accessLogs.entryPointPlaceholder": "e.g. Main Gate",
  "accessLogs.photo": "Photo",
  "accessLogs.perPage": "per page",
  "accessLogs.paginationInfo": "Showing {from}-{to} of {total} records",
  "accessLogs.goToPage": "Go to page",
  "accessLogs.registered": "Access registered successfully",
  "accessLogs.error.timeout": "The door took too long to respond. Try opening again.",
  "accessLogs.error.authFailed": "We couldn't open it right now. Try again or head to the guard booth.",
  "accessLogs.error.signatureFailed": "We couldn't open it right now. Try again or head to the guard booth.",
  "accessLogs.error.generic": "We couldn't complete the opening. Please try again.",

  // Shift Status
  "shift.status.active": "Active",
  "shift.status.completed": "Completed",
  "shift.status.abandoned": "Abandoned",

  // Shift Required Messages
  "shift.required.title": "Shift not started",
  "shift.required.message": "You must start your shift before you can use this feature. Your shift records all the activities you perform during your workday.",
  "shift.required.action": "Start Shift Now",
  "shift.required.hint": "Your shift will be automatically registered",
  "shift.notes.optional": "Start notes (optional)",
  "shift.notes.placeholder": "Initial observations...",
  "shift.noShift": "No active shift",
  "shift.startFirst": "Start your shift to continue",

  // Common additions for Access Logs
  "common.search": "Search",
  "common.filters": "Filters",
  "common.clearFilters": "Clear filters",
  "common.showingOf": "Showing {from}-{to} of {total}",

  // Menu additions
  "menu.accessLogs": "Access Logs",

  // Validation errors
  "validation.isString": "Must be text",
  "validation.maxLength": "Maximum {max} characters",
  "validation.minLength": "Minimum {min} characters",
  "validation.isEmail": "Must be a valid email",
  "validation.isNotEmpty": "This field is required",
  "validation.isNumber": "Must be a number",
  "validation.isPhoneNumber": "Must be a valid phone number",
  "validation.isBoolean": "Must be true or false",
  "validation.isDate": "Must be a valid date",
  "validation.isDateString": "Must be a valid date",
  "validation.isArray": "Must be a list",
  "validation.isUrl": "Must be a valid URL",
  "validation.isUuid": "Must be a valid identifier",
  "validation.isPositive": "Must be a positive number",
  "validation.max": "The maximum value is {max}",
  "validation.min": "The minimum value is {min}",
  "validation.isEnum": "Must be one of: {values}",
  "validation.unknown": "Invalid value",

  // Admin Layout V2
  "menu.v2.comingSoon": "Coming soon",
  "menu.v2.myProfile": "My Profile",
  "menu.v2.logout": "Logout",
  "menu.residentes": "Residents",
  "menu.unidades": "Units",
  "menu.secciones": "Sections",
  "menu.reservas": "Reservations",
  "menu.visitas": "Visitors",
  "menu.personal": "Staff",
  "menu.finanzas": "Finance",
  "menu.cuotas": "Charges",
  "menu.presupuesto": "Budget",
  "menu.mantenimiento": "Maintenance",
  "menu.v2.kpi.ocupacion": "Occupancy",
  "menu.v2.kpi.cobranza": "Collections",
  "menu.v2.kpi.satisfaccion": "Satisfaction",
  "menu.v2.kpi.seguridad": "Security",
  "menu.v2.insight.title": "Hommi AI · Insight",
  "menu.v2.insight.desc": "Intelligent analysis for your community is coming soon.",
  "menu.v2.alerts.title": "Critical Alerts",
  "menu.v2.activity.title": "Live Activity",
  "menu.v2.finance.title": "Financial Summary",
  "menu.v2.lastAccess.title": "Latest Access Logs",
  "menu.v2.camera.title": "Live Camera",
  "menu.v2.upcoming.title": "Upcoming Expenses",
  "menu.v2.search.placeholder": "Search unit, resident or report...",
  "menu.v2.status.updated": "Updated 2 min ago",
  "menu.v2.accesos": "Access Control",
  "menu.v2.incidentes": "Incidents",
  "menu.v2.puntosAcceso": "Access Points",
  "menu.v2.rfid": "RFID Cards",
  "menu.v2.amenidadesReg": "Amenity Log",
  "menu.v2.gastos": "Expenses",
  "menu.v2.notificacionesConfig": "Notifications",
  "menu.v2.auditoria": "Audit",
  "menu.v2.configuracion": "Settings",
  "menu.v2.routines": "Routines",
  "menu.v2.documents": "Documents",
  "menu.v2.payments": "Payments",
  "menu.v2.inicio": "Home",
  "menu.v2.actividad": "Activity",
  "menu.v2.ajustes": "Settings",
  "menu.v2.notificacionesReglas": "Notification rules",
  "menu.v2.sidebar.collapse": "Collapse menu",
  "menu.v2.sidebar.expand": "Expand menu",

  "routines.title": "Scheduled Routines",
  "routines.subtitle": "Recurring automations for your community",
  "routines.search": "Search routine...",
  "routines.filterCategory": "Category",
  "routines.filterEnabled": "Status",
  "routines.allCategories": "All categories",
  "routines.allStatuses": "All statuses",
  "routines.enabled": "Active",
  "routines.disabled": "Paused",
  "routines.runNow": "Run now",
  "routines.toggle.enable": "Enable",
  "routines.toggle.disable": "Pause",
  "routines.delete": "Delete",
  "routines.edit": "Edit",
  "routines.create": "New Routine",
  "routines.executions": "View executions",
  "routines.status.idle": "Idle",
  "routines.status.running": "Running",
  "routines.status.success": "Successful",
  "routines.status.failed": "Failed",
  "routines.lastRun": "Last run",
  "routines.nextRun": "Next run",
  "routines.triggerSummary": "Frequency",
  "routines.category.billing": "Billing",
  "routines.category.access": "Access",
  "routines.category.gdpr": "GDPR",
  "routines.category.restrictions": "Restrictions",
  "routines.category.maintenance": "Maintenance",
  "routines.category.custom": "Custom",
  "routines.category.uncategorized": "Uncategorized",
  "routines.executionStatus.running": "Running",
  "routines.executionStatus.success": "Success",
  "routines.executionStatus.failed": "Failed",
  "routines.executionStatus.cancelled": "Cancelled",
  "routines.executionStatus.skipped": "Skipped",
  "routines.noRoutines": "No routines configured",
  "routines.noExecutions": "No execution history",
  "routines.form.name": "Name",
  "routines.form.description": "Description",
  "routines.form.category": "Category",
  "routines.form.action": "Action",
  "routines.form.cronExpression": "Cron Expression",
  "routines.form.timezone": "Timezone",
  "routines.form.enabled": "Enable on create",
  "routines.form.save": "Save",
  "routines.form.cancel": "Cancel",
  "routines.form.validateCron": "Validate",
  "routines.form.cronValid": "Valid expression",
  "routines.form.cronInvalid": "Invalid expression",
  "routines.form.nextRuns": "Next runs:",
  "routines.modal.createTitle": "New Routine",
  "routines.modal.editTitle": "Edit Routine",
  "routines.modal.executionsTitle": "Execution History",
  "routines.deleteConfirm.title": "Delete Routine",
  "routines.deleteConfirm.message": "Are you sure you want to delete this routine? This action cannot be undone.",
  "routines.triggerSuccess": "Routine triggered. ID: {{executionId}}",
  "routines.toggleSuccess.enabled": "Routine enabled",
  "routines.toggleSuccess.disabled": "Routine paused",
  "routines.deleteSuccess": "Routine deleted",
  "routines.createSuccess": "Routine created",
  "routines.updateSuccess": "Routine updated",
  "routines.failureCount_one": "{{count}} failure",
  "routines.failureCount_other": "{{count}} failures",
  "routines.duration": "{{ms}}ms",
  "routines.resultCount": "{{count}} records",
  "routines.attempt": "Attempt {{n}}",
  "routines.triggered.schedule": "Scheduled",
  "routines.triggered.manual": "Manual",
  "routines.triggered.retry": "Retry",

  // Recorridos GPS (Incremento 4)
  "menu.v2.recorridos": "Routes",
  "guardRoutes.title": "Routes",
  "guardRoutes.subtitle": "Guard GPS routes",
  "guardRoutes.guard": "Guard",
  "guardRoutes.allGuards": "All guards",
  "guardRoutes.from": "From",
  "guardRoutes.to": "To",
  "guardRoutes.clear": "Clear filters",
  "guardRoutes.retry": "Retry",
  "guardRoutes.empty": "No routes match these filters",
  "guardRoutes.unknownGuard": "Unnamed guard",
  "guardRoutes.inProgress": "Route in progress",
  "guardRoutes.page": "Page {{page}} of {{total}}",
  "guardRoutes.selectRoute": "Pick a route to see its trace",
  "guardRoutes.noPoints": "This route has no recorded points",
  "guardRoutes.distance": "Distance",
  "guardRoutes.pace": "Pace",
  "guardRoutes.duration": "Time",
  "guardRoutes.stops": "Stops",
  "guardRoutes.gaps": "No signal",
  "guardRoutes.points": "Points",
  "guardRoutes.start": "Start",
  "guardRoutes.end": "End",
  "guardRoutes.stop": "Stop",
};
